import createInlineButtons from './inline-buttons.js';
import createInsertButtons from './insert-buttons.js';
import 'wix-rich-content-plugin-commons';
import 'wix-rich-content-editor-common';
import './giphyInsertModal.js';
import 'react';
import '../giphyApiInputModal-d33234ba.js';
import 'prop-types';
import 'wix-rich-content-common';
import 'wix-rich-content-ui-components';
import '../style-inject.es-746bb8ed.js';
import './giphySelector.js';
import 'react-infinite-scroller';
import 'react-md-spinner';
import 'react-custom-scrollbars';
import '../constants.js';
import '../giphyEmptyState-908a0922.js';
import '../icons/PoweredByGiphy.js';
import 'classnames';
import 'lodash';
import '../types.js';
import '../icons/MediaReplaceIcon.js';
import '../icons/InsertPluginIcon.js';

const createToolbar = ({
  t,
  settings,
  isMobile
}) => {
  return {
    InlineButtons: createInlineButtons({ t, settings, isMobile }),
    InsertButtons: createInsertButtons({ t, settings, isMobile }),
    name: "giphy"
  };
};

export { createToolbar as default };
//# sourceMappingURL=createToolbar.js.map
